import OfferWall from './OfferWall';

export default OfferWall;
